import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/hide_image.svg'


const _withScopeId = n => (_pushScopeId("data-v-01a042b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dicom-web-viewer-wrapper" }
const _hoisted_2 = { class: "top_box" }
const _hoisted_3 = {
  key: 0,
  class: "dicom_info_box"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "new_icon",
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "9.5",
  fill: "#FF4646"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M13 6V14H11.4934L7.80795 8.91713H7.73841V14H6V6H7.5298L11.1921 11.0829H11.2732V6H13Z",
  fill: "white"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg width=\"15\" height=\"17\" viewBox=\"0 0 15 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-01a042b6><g clip-path=\"url(#clip0_594_2263)\" data-v-01a042b6><path d=\"M12.7377 13.6223C12.2851 13.6223 11.9209 13.9914 11.9209 14.4499V16.9888L14.9673 13.6223H12.7266H12.7377Z\" fill=\"#0B8EF0\" data-v-01a042b6></path><path d=\"M12.936 0H2.05298C0.916115 0 0 0.92829 0 2.08026V14.9086C0 16.0605 0.916115 16.9888 2.05298 16.9888H10.7064V14.4612C10.7064 13.3539 11.5894 12.448 12.6932 12.448H15V2.08026C15 0.92829 14.0839 0 12.947 0H12.936ZM3.17881 6.67697H8.26711V7.69474H3.17881V6.67697ZM10.3974 10.3678H3.17881V9.35H10.4084V10.3678H10.3974ZM11.8212 5.0329H3.17881V4.01513H11.8212V5.0329Z\" fill=\"#0B8EF0\" data-v-01a042b6></path></g><defs data-v-01a042b6><clipPath id=\"clip0_594_2263\" data-v-01a042b6><rect width=\"15\" height=\"17\" fill=\"white\" data-v-01a042b6></rect></clipPath></defs></svg><h3 data-v-01a042b6>Confirmed list</h3>", 2)
const _hoisted_11 = {
  ref: "viewerElement",
  class: "viewer-wrapper"
}
const _hoisted_12 = {
  key: 0,
  class: "no_img_wrap"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-area" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "no_img_wrap"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no_img_box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "No Image"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "No image")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "no_img_wrap"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  style: {"position":"relative"},
  class: "canvas-wrap"
}
const _hoisted_22 = {
  style: {"position":"relative"},
  class: "canvas-wrap"
}
const _hoisted_23 = {
  ref: "tubeCanvas",
  class: "mask-overlay",
  style: {"position":"absolute","z-index":"20"}
}
const _hoisted_24 = {
  ref: "probCanvas",
  class: "mask-overlay",
  style: {"position":"absolute","z-index":"10"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.dicomFile.origin_filename)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.dicomFile.origin_filename), 1)
          ]))
        : (_openBlock(), _createElementBlock("h3", _hoisted_4, "Viewer")),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn__default blue pacs_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePacsBtnClick()))
        }, "PACS"),
        _createElementVNode("div", {
          class: _normalizeClass(["btn__default blue result_btn", {inactive: _ctx.readingResultList.length==0}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRstListClick()))
        }, [
          (_ctx.setShowNewIcon && _ctx.readingResultList.length>0)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          _hoisted_9
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["btn__default blue tag_btn", { inactive: !Object.values(_ctx.dicomFile).length || _ctx.showLoadingBox }]),
          style: {"margin-left":"10px"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDicomTagClick()))
        }, "Dicom Tag", 2),
        (_ctx.withCAD)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["btn__default blue export_btn", { inactive: !Object.values(_ctx.dicomFile).length || _ctx.showLoadingBox }]),
              style: {"margin-left":"10px"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleExportClick()))
            }, "Export", 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      ((_ctx.withCAD && _ctx.showLoadingBox && _ctx.dicomImageElement==null) || (!_ctx.withCAD && _ctx.showLoadingBox))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        : ((!_ctx.showLoadingBox && _ctx.dicomImageElement==null) || _ctx.activeDeleteBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : (_ctx.withCAD && !_ctx.fileLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.dicomImageElement!=null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "png-image",
                      innerHTML: _ctx.dicomImageElement?.outerHTML
                    }, null, 8, _hoisted_19))
                  : _createCommentVNode("", true),
                (_ctx.withCAD && _ctx.analysisImageElement!=null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "png-image",
                      innerHTML: _ctx.analysisImageElement?.outerHTML
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          ref: "dicomElementLeft",
          class: "dicom-container",
          style: _normalizeStyle({ visibility: !_ctx.withCAD || _ctx.fileLoaded ? 'visible' : 'hidden' })
        }, null, 4)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", {
          ref: "dicomElementRight",
          class: "dicom-container",
          style: _normalizeStyle({ visibility: !_ctx.withCAD || _ctx.fileLoaded ? 'visible' : 'hidden' })
        }, null, 4),
        _createElementVNode("div", {
          ref: "maskElement",
          class: "dicom-container",
          style: _normalizeStyle([{"position":"absolute","right":"0","top":"50%","transform":"translateY(-50%)","display":"flex","align-items":"center","justify-content":"center"}, { opacity: !_ctx.fileLoaded ? '0' : '1' }])
        }, [
          _withDirectives(_createElementVNode("canvas", _hoisted_23, null, 512), [
            [_vShow, _ctx.showTubeCanvas]
          ]),
          _withDirectives(_createElementVNode("canvas", {
            ref: "heatmapCanvas",
            class: "mask-overlay",
            style: _normalizeStyle([{"position":"absolute","z-index":"15"}, { opacity: _ctx.showProbCanvas ? 0.3 : 1 }])
          }, null, 4), [
            [_vShow, _ctx.showHeatmapCanvas]
          ]),
          _withDirectives(_createElementVNode("canvas", _hoisted_24, null, 512), [
            [_vShow, _ctx.showProbCanvas]
          ])
        ], 4)
      ], 512), [
        [_vShow, _ctx.withCAD&&(_ctx.showTubeCanvas||_ctx.showHeatmapCanvas||_ctx.showProbCanvas)]
      ])
    ], 512)
  ]))
}